import * as types from '../actionTypes'

export const acceptCookies = accepted => ({
    type: types.SET_COOKIE_CONSENT,
    payload: accepted,
})
